/**
 * Servicio que se encarga del manejo de las peticiones sobre los tecnicos que son asignados
 * en el detalle de una pqr.
 * JMM-2018-07-18
 */
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service'; 

@Injectable()
export class TecnicoasignadopqrService {

  public tecnicoasignadopqr : any[] = [];
  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}

  /**
   * Obtener el listado de registros
   * JMM-2018-07-18
   */
  getTecnicoasignadoPqr()
  {
    let url = this.PATH + '/api/public/tecnicoasignadopqr';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getTecnicoasignadoPqr()

  /**
   * Obtener un registro por id para editar
   * JMM-2018-07-18
   */
  getRegTecnicoAsignadoPqr(id:any)
  {
    let url = this.PATH + '/api/public/tecnicoasignadopqr/' + id;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getRegTecnicoAsignadoPqr(id:any)

  /**
   * Enviar registro del Tecnico asignado en el detalle de la PQR para guardarlo en bd
   * JMM-2018-07-18
   */
  setTecnicoAsignadoPqr(tecnicoasignadopqr:any)
  {
    let url = this.PATH + '/api/public/tecnicoasignadopqr';
    return this.http.post(url, tecnicoasignadopqr, {headers:this._key.head()}).map(resp => resp.json());
  }// .setTecnicoAsignadoPqr(tecnicoasignadopqr:any)

  /**
   * Editar registro del Tecnico asignado en el detalle de la PQR en bd
   * JMM-2018-07-18
   */
  editTecnicoAsignadoPqr(tecnicoasignadopqr:any)
  {
    let url = this.PATH+'/api/public/tecnicoasignadopqr/'+tecnicoasignadopqr.id; 
    return this.http.put(url, tecnicoasignadopqr, {headers:this._key.head()}).map( resp => resp.json()); 
  }// .editTecnicoAsignadoPqr(tecnicoasignadopqr:any)

  /**
   * Obtener los detalles de un tecnico asignado en el detalle de una pqr
   * JMM-2018-07-18
   */
  getTecnicoAsignadoPqr(detallepqrid:any)
  {
    let url = this.PATH+'/api/public/registrostecnicoasignadopqr/'+detallepqrid; 
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json()); 
  }// .getTecnicoAsignadoPqr(tecnicoasignadopqrid:any)

    /**
   * Obtener el listado de los tecnicos asignados a la pqr
   * CESAR ARIAS 21//03/2019
   */
  TecnicoAsignadoPqr(pqrid:any)
  {
    let url = this.PATH+'/api/public/TecnicoAsignadoPqr/'+pqrid; 
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json()); 
  }// .TecnicoAsignadoPqr(pqrid:any)
  

    /**
   * Obtener el listado de los tecnicos asignados a la pqr en informes para los filtros
   * CESAR ARIAS 21//03/2019
   */
  TecnicoAsignadoPqrInforme()
  {
    let url = this.PATH+'/api/public/TecnicoAsignadoPqrInforme'; 
    return this.http.get(url, {headers:this._key.head()}).map( resp => resp.json()); 
  }// .TecnicoAsignadoPqrInforme(pqrid:any)

  /**
   * Permite obtener el identificador del ultimo registro
   * JMM-2018-10-31
   */
  generaConsecutivoTecnicoAsignadoPqr()
  {
    let url = this.PATH + '/api/public/generaConsecutivoTecnicoasignadopqr';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json()); 
  }// .generaConsecutivoTecnicoAsignadoPqr()

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/pqr/tecnicoasignadopqr.service.ts